/*
  Small shared behaviours for the clc-* sections: accordions (FAQ, and the mobile
  curricula list) and click-to-play video posters.
*/
(function () {
  function closeSiblings(list, current) {
    list.querySelectorAll('[data-clc-toggle]').forEach(function (button) {
      if (button !== current) {
        button.setAttribute('aria-expanded', 'false');
      }
    });
  }

  document.addEventListener('click', function (evt) {
    var target = evt.target;
    if (!target || typeof target.closest !== 'function') return;

    var toggle = target.closest('[data-clc-toggle]');

    if (toggle) {
      var list = toggle.closest('[data-clc-accordion]');
      var expanded = toggle.getAttribute('aria-expanded') === 'true';

      if (list && list.dataset.clcAccordion === 'single' && !expanded) {
        closeSiblings(list, toggle);
      }

      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      return;
    }

    var poster = target.closest('[data-clc-video]');
    if (poster) {
      play(poster);
    }
  });

  function play(poster) {
    if (poster.classList.contains('is-playing')) return;

    var embed = poster.dataset.clcVideo;
    if (!embed) return;

    var wrapper = document.createElement('div');
    wrapper.innerHTML = embed;

    var media = wrapper.firstElementChild;
    if (!media) return;

    if (media.tagName === 'IFRAME') {
      media.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      media.setAttribute('allowfullscreen', 'allowfullscreen');
    } else {
      media.setAttribute('controls', 'controls');
      media.autoplay = true;
    }

    poster.classList.add('is-playing');
    poster.appendChild(media);

    if (media.tagName === 'VIDEO' && media.play) {
      media.play();
    }
  }

  document.addEventListener('clc:variantChange', function (evt) {
    var handle = evt.detail && evt.detail.handle;
    if (!handle) return;
    document.querySelectorAll('[data-clc-copy]').forEach(function (el) {
      var key = el.getAttribute('data-clc-copy');
      if (!key) return;
      el.classList.toggle('is-hidden', key !== handle);
    });
  });
})();
